import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
    Container,
    Typography,
    Box,
    Button,
    Divider
} from '@material-ui/core';
import { deleteAccount } from '../../../actions/userActions';
import EmailEditor from './AccountEdit/EmailEditor';
import PasswordEditor from './AccountEdit/PasswordEditor';
import Alert from '../../../utils/alert';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        padding: theme.spacing(3),
    },
    heading: {
        fontSize: '1.8rem',
        fontWeight: 600,
        color: '#363636',
        marginBottom: theme.spacing(4),
    },
    section: {
        marginBottom: theme.spacing(2),
    },
    passwordSection: {
        marginTop: theme.spacing(4),
    },
    deleteSection: {
        marginTop: theme.spacing(6),
    },
    divider: {
        margin: theme.spacing(3, 0),
    },
    deleteButton: {
        backgroundColor: '#f14668',
        color: '#fff',
        fontSize: '1.2rem',
        textTransform: 'none',
        padding: '0.5em 1em',
        '&:hover': {
            backgroundColor: '#ef2e55',
        },
    },
}));

function AccountEdit() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const handleDeleteAccount = () => {
        Alert.confirm("このアカウントを本当に削除しますか？")
            .then((result) => {
                if (result.value) {
                    dispatch(deleteAccount());
                }
            });
    };

    return (
        <Container className={classes.root}>
            <Typography variant="h1" className={classes.heading}>
                アカウント設定
            </Typography>
            <Box>
                <Box className={classes.section}>
                    <EmailEditor />
                </Box>
                <Box className={classes.passwordSection}>
                    <PasswordEditor />
                </Box>
                <Box className={classes.deleteSection}>
                    <Divider className={classes.divider} />
                    <Button
                        variant="contained"
                        className={classes.deleteButton}
                        onClick={handleDeleteAccount}
                    >
                        アカウントを削除する
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}

export default AccountEdit;